import * as types from '@/store/types'
import { throwError } from '@/utils/store'

export default {
  [types.FETCH_CAMPAIGNS]: ({ commit, getters }) => {
    const name = types.CAMPAIGNS

    commit(types.LOADING, name)
    return getters.apiService
      .fetchCampaigns()
      .then(list => commit(types.SET_LIST, { name, list }))
      .catch(throwError(commit, 'Ошибка получения списка кампаний'))
      .finally(() => commit(types.LOADED, name))
  }
}
